<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="custom-file-format-wrapper">
    <div class="actions">
      <div class="add-extension-btn">
        <button [disableRipple]="true" mat-raised-button color="primary" (click)="onAddExtensionClick()">
          <span class="mdi mdi-plus-box-outline icon"></span>
          <span class="add-button-label">{{'FILE_TYPE' | translate}}</span>
        </button>
      </div>
      <div class="import-wrapper">
        <div class="import-btn">
          <span class="add-extension-btn">
              <button id="import-folders-button" [disableRipple]="true" color="primary"
                      mat-raised-button (click)="onImportClick()" aria-label="Import folders.">
                  <span class="mdi mdi-download icon"></span>
                  <span class="add-button-label">{{'IMPORT' | translate}}</span>
              </button>
          </span>
        </div>
        <div class="import-error-wrapper">
          <div class="import-error" [ngClass]="{'hide': importErrors === 0}">{{importErrors}} {{'IMPORT_ERRORS' | translate}}</div>
        </div>
      </div>
    </div>
    <form [formGroup]="fileFormatFormGroup">
        <div formArrayName="fileFormats" class="ext-row-wrapper">
            <span class="protection-level-title">
                {{'PROTECTION_LEVEL' | translate}}
                <span role="application" class="fa-layers fa-fw clickable question-icon" (keyup.enter)="onProtectionLevelClick()" (click)="onProtectionLevelClick()">
                    <span tabindex="0" class="mdi mdi-help-circle-outline"></span>
                </span>
            </span>
            <div class="ext-row" autocomplete="off" id="ext-path-{{i}}" *ngFor="let control of controls; let i = index;" [formGroupName]="i">
                <mat-form-field floatLabel="never" class="policy-path-form-field" appearance="outline">
                    <input matInput type="text" autocomplete="off" id="text-ext-path-{{i}}" formControlName="extension" class="ext-label input-edit-mode" #extensionInputs
                        appDebounceInput
                        [debounceTime]="250"
                        [ngClass]="{'input-error': hasExtensionError(i)}"
                        (focusin)="onFocusIn($event, i)"
                        (focusout)="onFocusOut($event, i)"
                        (debounceInput)="onInputChange($event, control, i)" 
                        formControlName="path"
                        placeholder="{{'FILE_EXTENSION' | translate}}"/>
                </mat-form-field>
                <span class="policy-toggle-button-group">
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" value="{{control.value.setting}}" formControlName="setting" (change)="onToggleChanged($event, control, i)" [appearance]="toggleGroupAppearance" name="policy-toggle-button-group">
                        <mat-button-toggle id="none-{{i}}" value="none-{{i}}" [disabled]="control.value.setting === ''" disableRipple="true" [checked]="true">{{'NONE' | translate}}</mat-button-toggle>
                        <mat-button-toggle id="medium-{{i}}" value="medium-{{i}}" [disabled]="control.value.setting === ''" disableRipple="true">Dynamic</mat-button-toggle>
                        <mat-button-toggle id="high-{{i}}" value="high-{{i}}" [disabled]="control.value.setting === '' || !allowAlwaysOn" disableRipple="true">Always on</mat-button-toggle>
                    </mat-button-toggle-group>
                </span>
                <span class="remove-row-icon">
                    <button [disableRipple]="true" mat-icon-button (click)="removeExtensionRow(control.value.path, i)"
                            matTooltip="{{'REMOVE_FILE_EXT' | translate}}" matTooltipPosition="right"
                            attr.aria-label="{{'REMOVE_FILE_EXT' | translate}}.">
                        <span class="mdi mdi-close-circle-outline"></span>
                    </button>
                </span>
                <div *ngIf="hasExtensionError(i)" style="margin: -18px 0 0 0;color: #c90000;font-size: 12px;">{{extensionErrors[i]}}</div>
            </div>
        </div>
    </form>
</div>
